import React, { useRef } from 'react';
import { renderers } from './renderers';

export default function Renderer(props) {
    const length = useRef(0);
    let { content, contentDisplayType } = props;
    let contentType = String(props.contentType).toLowerCase();

    if (props.overrideHTML && props.overrideHTML.length) {
        contentType = 'html';
        content = props.overrideHTML;
    }

    const parseContentDisplayText = (content, type) => {
        if (!content) {
            return '';
        }

        if (type == 'FIB') {
            let match = content.match(/{(\d+)}/);
            if (match) {
                // Extracted number
                length.current = match[1];
                // return content.replace(/{(\d+)}/g, '::');
            }
        }

        return content;
    }
    if (props.contentDisplayType) {
        content = parseContentDisplayText(content, contentDisplayType);
        if (props.contentDisplayType === 'FIB') {
            contentType = 'fib-text';
        }
    }
    const Renderer = renderers[contentType];
    return Renderer && <Renderer {...props} length={Number(length.current)} content={content} />;

    // const FinalRenderer = renderers[contentType];
    // return FinalRenderer && <FinalRenderer {...props} length={Number(length.current)} content={content} />;
}